import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { baseUrl, customHeaders } from '../../../../Containers/Config/index.js';
import { VIEW_FILE, VIEW_FILE_SUCCESS, VIEW_FILE_ERROR } from './../../actionType.js';
import apiCall from '../../apiCall';
import { Constant } from '../../../../Containers/Helpers/constant.js';

function* viewFile({ payload }) {
  try {
    const response = yield call(apiCall, {
      url: `${baseUrl}/admin/view-file`,
      method: 'GET',
      headers: {
        Authorization: Constant?.CLIENT_TOKEN,
        ...customHeaders,
      },
      params: {
        ...payload?.urlParams,
      },
    });

    if (response.status === 200) {
      yield put({
        type: VIEW_FILE_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: VIEW_FILE_ERROR,
        payload: response?.data?.message,
      });
    }
  } catch (error) {
    yield put({ type: VIEW_FILE_ERROR, payload: error });
  }
}

export function* watchViewFile() {
  yield takeEvery(VIEW_FILE, viewFile);
}

function* viewFileSaga() {
  yield all([fork(watchViewFile)]);
}

export default viewFileSaga;
